import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'payee-chip-toggle',
  templateUrl: './chip-toggle.component.html',
  styleUrls: ['./chip-toggle.component.scss'],
  imports: [MatIcon],
})
export class ChipToggleComponent {
  @Input({ required: true }) control!: FormControl<boolean | null>;
  @Input() label = '';

  toggle(): void {
    this.control.patchValue(!this.control.value);
  }

  clear(event: Event): void {
    event.stopPropagation();
    event.preventDefault();
    this.control.patchValue(false);
  }
}
